import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className="pt-12 pb-16 md:pt-20 md:pb-24 px-6 bg-[#FAF7F2] overflow-hidden" data-id="element-75">
      <div className="max-w-4xl mx-auto text-center" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-77">
          <span className="inline-block py-1 px-3 border border-[#C4A35A] text-[#C4A35A] text-xs tracking-widest uppercase mb-6 rounded-full" data-id="element-78">
            Vida Sin Tabú
          </span>

          <h1 className="text-4xl md:text-6xl font-serif font-medium text-[#2D2A26] leading-tight mb-6" data-id="element-79">
            No te falta deseo. <br data-id="element-80" />
            <span className="italic text-[#C4A35A]" data-id="element-81">Te sobra presión.</span>
          </h1>

          <p className="text-lg md:text-xl text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-82">
            Reinicio de deseo para parejas de larga relación. El método
            "Escalera de Cercanía" para volver a sentirse cerca sin obligación,
            sin tensión y sin actuar un personaje.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.3,
        duration: 0.8
      }} className="relative mx-auto mb-16 max-w-md md:max-w-lg shadow-2xl rounded-lg overflow-hidden" data-id="element-83">
          <img src="https://cdn.magicpatterns.com/uploads/5N39JyGBfBQEimpkUYj4vt/ChatGPT_Image_2_feb_2026,_15_55_11.png" alt="Intimidad Sin Presión - Libro Digital" className="w-full h-auto object-cover" data-id="element-84" />
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.8
      }} className="text-left max-w-2xl mx-auto bg-white p-8 md:p-12 shadow-sm border border-stone-100 rounded-sm" data-id="element-85">
          <p className="text-xl font-serif text-[#2D2A26] mb-6 leading-relaxed" data-id="element-86">
            Hay un tipo de soledad que duele más que estar soltero:
          </p>
          <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-87">
            Estar con tu persona… y sentir que el tema de la intimidad se volvió
            un campo minado.
          </p>
          <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-88">
            Porque no es solo "no pasó nada anoche". Es lo que viene después.
          </p>
          <p className="text-gray-700 mb-6 font-medium" data-id="element-89">
            El silencio. La frialdad. La sensación de que pedir es presionar… y
            de que decir que no es herir.
          </p>
          <p className="text-gray-700 mb-8 leading-relaxed" data-id="element-90">
            Si eso te suena, este PDF no está hecho para motivarte. Está hecho
            para darte un sistema.
          </p>

          <div className="text-center" data-id="element-91">
            <Button onClick={scrollToPricing} data-id="element-92">Descubrir el sistema</Button>
          </div>
        </motion.div>
      </div>
    </header>;
}